@let isDesktop = deviceService.isDesktop$ | async;
@let user = currentUser$ | async;

@if (isDesktop) {
  <section class="flex items-center">
    <div class="flex flex-col jusdtify-center items-center">
      <div
        tuiDropdownLimitWidth="min"
        [tuiDropdown]="profileLinks"
        class="mt-1"
        [(tuiDropdownOpen)]="dropdownOpen"
      >
        <button
          tuiButton
          type="button"
          tuiChevron
          appearance="icon"
          size="xs"
          class="no-opacity-btn"
        >
          <span class="x-text-dark-main x-font-body-4-bold">
            {{ user?.email }}
          </span>
        </button>
      </div>

      @if (permissionService.hasPermission$('showCurrentEnvironment') | async) {
        <span tuiBadge tuiStatus size="m" [appearance]="envConfig()['style']">{{
          envConfig()['title']
        }}</span>
      }
    </div>
    <span
      [tuiAvatar]="user?.fullname || '' | tuiInitials"
      [style.background]="user?.fullname || '' | tuiAutoColor"
      class="ms-3 cursor-pointer"
      [round]="true"
      size="l"
      routerLink="/profile"
    >
      @if (getAvatarUrl(user?.avatar); as avatarUrl) {
        <img alt="" [src]="avatarUrl" />
      }
    </span>
  </section>
} @else {
  <div>
    <span
      [tuiAvatar]="user?.fullname || '' | tuiInitials"
      [style.background]="user?.fullname || '' | tuiAutoColor"
      [round]="false"
      class="my-4"
      routerLink="/profile"
    >
      @if (getAvatarUrl(user?.avatar); as avatarUrl) {
        <img alt="" [src]="avatarUrl" />
      }
    </span>
    <div class="text-l truncate x-font-body-4-bold">{{ user?.fullname }}</div>
    <div
      tuiDropdownAuto
      tuiDropdownLimitWidth="fixed"
      [tuiDropdown]="profileLinks"
      class="mt-1"
    >
      <button
        tuiButton
        type="button"
        tuiChevron
        appearance="icon"
        size="s"
        [style.--tui-padding]="'0.25rem'"
        class="no-opacity-btn"
      >
        <span class="x-text-dark-main x-font-body-4">
          {{ user?.email }}
        </span>
      </button>
    </div>

    @if (permissionService.hasPermission$('showCurrentEnvironment') | async) {
      <div>
        <span tuiBadge tuiStatus size="m" [appearance]="envConfig()['style']">{{
          envConfig()['title']
        }}</span>
      </div>
    }
  </div>
}
<ng-template #profileLinks>
  <div class="p-2 bg-(--tui-background-base-alt) w-full">
    <ul>
      @if (isNotProfilePage()) {
        <li>
          <div class="mb-2">
            <button
              tuiButton
              type="button"
              size="s"
              class="w-full border! border-(--x-color-gray-50)! border-solid! button-bg-inverse"
              appearance="floating"
              routerLink="/profile"
              (click)="closeDropdown()"
            >
              <span class="x-font-body-4 font-semibold! x-text-dark-main"
                >Мой профиль</span
              >
            </button>
          </div>
        </li>
      }
      <li>
        <div class="mb-2">
          <ng-content />
        </div>
      </li>
      @if (isDesktop) {
        <li class="mb-2">
          <x-theme-selector class="shrink-0"></x-theme-selector>
        </li>
      }
      <li>
        <button
          tuiButton
          type="button"
          appearance="floating"
          class="w-full border! border-(--x-color-gray-50)! border-solid! button-bg-inverse"
          (click)="logout()"
        >
          <span class="x-font-body-4 font-semibold! text-(--x-color-danger)">
            {{ 'core.sidebar.logout' | translate }}
          </span>
        </button>
      </li>
    </ul>
  </div>
</ng-template>
